module.exports = __webpack_public_path__ + "static/media/addFile.ac0334f8.svg";